import React from 'react';

import dialogProps from '../types/dialogProps';
import dialogActions from '../hooks/useDialog/dialogActions';

import Nav, { navLayouts } from '../../MainNav/MainNav';
import Modal from './Modal/Modal';

const MobileNav = ({ onClose, status }: dialogProps): JSX.Element => {
    const isOpen = status === dialogActions.open;

    return (
        <Modal>
            <Modal.Flyout onClose={onClose} isOpen={isOpen}>
                <div className="flex justify-center items-center h-full">
                    <Nav callback={onClose} layout={navLayouts.column} />
                </div>
            </Modal.Flyout>
        </Modal>
    );
};

export default MobileNav;
